import { Component, OnInit, ElementRef, Inject, ViewChild } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { SharedModule } from '../shared/shared.module';
import { Observable, Subject, Subscription } from 'rxjs';

import { ActivatedRoute, UrlSegment } from '@angular/router';
import { Provider } from '../core/models/provider.model';
import { ProviderService } from '../core/services/provider.service';
import { ProviderService as Service} from '../core/models/provider-service.model';
import { ServiceDetailService } from '../core/services/service-detail.service';
//import { NewCartService } from '../core/services/new-cart.service';

import { Meta, Title } from '@angular/platform-browser';

import { HttpClientModule } from '@angular/common/http';
import { GalleryLightboxService } from '../core/services/gallery-lightbox.service';
import { CartService } from '../core/services/cart.service';

import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AbilityService as AbilityServiceModel } from "../core/models/ability-service.model";
import { AbilityService } from "../core/services/ability.service";
import { MyBookingsService } from '../core/services/my-bookings.service';
import * as moment from 'moment';
import { ProviderServiceService } from '../core/services/provider-service.service';

@Component({
  selector: 'app-service',
  templateUrl: './service.page.html',
  styleUrls: ['./service.page.scss'],
  standalone: true,
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
    SharedModule,
    HttpClientModule,
  ],
  providers: [ServiceDetailService],
})
export class ServicePage implements OnInit {
  @ViewChild('servicegalleryslider') gallerySlider: ElementRef | undefined;

  service$: Observable<Service>;
  service: Service | null = null;
  provider$: Observable<Provider>;
  abilities$: Observable<AbilityServiceModel[]>;
  filteredEmployees: any[] = [];
  filteredEmployeesSubscription: Subscription;

  lightboxUrl: string | null = null;
  lightboxAlt: string | null = null;
  lightbox: boolean = false;
  urlSegments: UrlSegment[] | [] = [];
  private loyaltySubscription: Subscription | null = null;
  loyaltyCycleDiscountedPrice: number = 0;

  jsonLD: any;

  constructor(
    private titleService: Title,
    private providerService: ProviderService,
    private route: ActivatedRoute,
    private serviceDetailService: ServiceDetailService,
    public cartService: CartService,
    private lightboxService: GalleryLightboxService,
    private elementRef: ElementRef,
    private meta: Meta,
    @Inject(DOCUMENT) private document: Document,
    private abilityService: AbilityService,
    private myBookingsService: MyBookingsService
  ) {
    this.service$ = this.serviceDetailService
      .getServiceByPageRoute$(this.route.paramMap)
      .pipe(
        tap((service) =>
          this.titleService.setTitle(
            service.name + ' | ' + service.parentName + ' | dm Studio'
          )
        ),
        tap((service) => this.lightboxService.setGalleryFromService(service)),
        tap((service) =>
          this.meta.updateTag({
            property: 'og:title',
            content:
              service.name +
              ' | ' +
              service.parentName +
              ' | dm Studio | Service',
          })
        ),
        tap((service) =>
          this.meta.updateTag({
            property: 'og:description',
            content: service.longDescription,
          })
        ),
        tap((service) =>
          this.meta.updateTag({
            property: 'og:image',
            content:
              service?.avatar?.url ||
              'https://docs.api.pricepilot.io/652dadba274e4.jpeg',
          })
        ),
        tap(
          (service) =>
            (this.abilities$ = this.abilityService.getAbilitiesByServiceIds$([
              service?.id,
              service?.parentId,
              service?.grandParentId,
            ]))
        ),
        tap((service) => (this.service = service)),
        tap((service) => this.setJsonLd(service))
        // tap(() => this.filteredEmployees = this.abilityService.filteredEmployees$)
      );


    this.meta.updateTag({
      property: 'og:url',
      content: environment.siteUrl + '/' + route.snapshot['_routerState'].url,
    });
    this.route.url.subscribe((urlSegments) => {
      this.urlSegments = urlSegments;
    });
    this.provider$ = this.providerService.getProvider$();
  }

  ngOnInit() {
    this.filteredEmployeesSubscription = this.abilityService.filteredEmployees$
      .pipe(tap((employees) => (this.filteredEmployees = employees)))
      .subscribe();
    // console.log(this.filteredEmployees);



    this.loyaltySubscription = this.myBookingsService.pastServices$.subscribe(
      (services) => {
        this.cartService.loyaltyServices.next(services);

        const hasLoyaltyDiscount = services.get(this.service?.id + '');
        if (this.service && hasLoyaltyDiscount) {
          //console.log('hasLoyaltyDiscount', hasLoyaltyDiscount);
          this.service.loyaltyCycle = true;
          this.service.loyaltyCycleDiscountPercentage = hasLoyaltyDiscount[1];
          this.service.loyaltyExpirationDate = moment(
            hasLoyaltyDiscount[3]
          ).format('LLLL');
          // try {
          // this.service.discount = hasLoyaltyDiscount[1];
          // this.service.minimalPrice!.lowestPrice =
          // (this.service?.regularPrice1 || 0) *
          // (1 - hasLoyaltyDiscount[1] / 100);
          // } catch (e) {
          // console.error('Error setting loyalty discount', e);
          // }
          try {
            this.service.discount = hasLoyaltyDiscount[1];
            // this.service.minimalPrice!.lowestPrice =
            //   (this.service?.regularPrice1 || 0) *
            //   (1 - hasLoyaltyDiscount[1] / 100);
          } catch (e) {
            console.error('Error setting loyalty discount', e);
          }
          // console.log('this.service', this.service.minimalPrice?.lowestPrice, this.service.regularPrice1, this.service.discount);
          this.loyaltyCycleDiscountedPrice =
            (this.service?.minimalPrice?.lowestPrice ||
              this.service?.regularPrice1) *
            (1 - (this.service?.loyaltyCycleDiscountPercentage || 0) / 100);
        }
        // Do something with the past services
      }
    );
  }

  ngOnDestroy() {
    this.filteredEmployeesSubscription.unsubscribe();
    this.loyaltySubscription?.unsubscribe();
  }

  openLightbox(url: string, alt: string) {
    this.lightboxService.openLightbox(url, alt);
  }

  openLightbox2(service: any, index: number) {
    this.lightboxService.openLightbox2(
      service,
      index,
      undefined,
      this.urlSegments
    );
  }

  openLightbox3(galleryIndex: number) {
    this.lightboxService.openLightbox3(galleryIndex); //, undefined, this.urlSegments);
  }

  closeLightbox() {
    this.lightboxService.closeLightbox();
  }

  // after clicking on element, trigger click on another element
  triggerElementClick(elementId: string) {
    const element: HTMLElement = document.getElementById(
      elementId
    ) as HTMLElement;
    element.click();
  }

  animateAddToCart() {
    const r = document.querySelector(':root');
    const itemToBeAdded = document.querySelectorAll('.itemToBeAdded')[
      document.querySelectorAll('.itemToBeAdded').length - 1
    ] as HTMLElement;

    if (itemToBeAdded) {
      // use card image
      (itemToBeAdded as HTMLImageElement).src =
        this.elementRef.nativeElement.querySelector('.img img').src;
      // set position
      itemToBeAdded.style.top =
        this.elementRef.nativeElement.getBoundingClientRect().top +
        this.elementRef.nativeElement.getBoundingClientRect().height / 2 +
        'px';
      itemToBeAdded.style.left =
        this.elementRef.nativeElement.getBoundingClientRect().left +
        this.elementRef.nativeElement.getBoundingClientRect().width / 2 +
        'px';

      // set starting position for animation
      (r as HTMLElement).style.setProperty(
        '--moveToCartX',
        this.elementRef.nativeElement.getBoundingClientRect().left +
          this.elementRef.nativeElement.getBoundingClientRect().width / 2 +
          'px'
      );
      (r as HTMLElement).style.setProperty(
        '--moveToCartY',
        this.elementRef.nativeElement.getBoundingClientRect().top +
          this.elementRef.nativeElement.getBoundingClientRect().height / 2 +
          'px'
      );

      // apply animation
      itemToBeAdded.classList.add('drop-into-cart');
      // remove animation after 2 seconds
      setTimeout(() => {
        itemToBeAdded.classList.remove('drop-into-cart');
        itemToBeAdded.style.top = -100 + 'px';
      }, 2000);
    }
  }

  slideRight() {
    if (this.gallerySlider) {
      const currentLeft = this.gallerySlider.nativeElement.scrollLeft;
      const newLeft =
        currentLeft + this.gallerySlider.nativeElement.offsetWidth * 0.11;
      this.gallerySlider.nativeElement.scrollTo({
        left: newLeft,
        behavior: 'smooth',
      });
    }
  }

  slideLeft() {
    if (this.gallerySlider) {
      const currentLeft = this.gallerySlider.nativeElement.scrollLeft;
      const newLeft =
        currentLeft - this.gallerySlider.nativeElement.offsetWidth * 0.11;
      this.gallerySlider.nativeElement.scrollTo({
        left: newLeft,
        behavior: 'smooth',
      });
    }
  }

  setJsonLd(service: Service) {
    this.jsonLD = {
      '@context': 'https://schema.org',
      '@type': 'Product',
      serviceType: service.name,
      name: service.name,
      image: service.avatarUrl(),
      description: service.longDescription,
      logo: 'https://www.dmstudio.si/assets/images/logo_v1.png',
      provider: {
        '@type': 'Organization',
        name: 'dm Studio',
      },
      offers: {
        '@type': 'Offer',
        url: service.serviceUrl(),
        priceCurrency: 'EUR',
        price: service.minimalPrice?.lowestPrice || 0,
        priceValidUntil: moment().add(1, 'days').format('YYYY-MM-DD'),
        availability: 'https://schema.org/InStock',
        seller: {
          '@type': 'Organization',
          name: 'dm Studio',
        },
      },
    };
  }
}
